import { cn } from '@rocco/utils/cn';
import { useCallback } from 'react';

interface TagMarkerProps extends React.HTMLAttributes<HTMLDivElement> {
    isApproved: boolean;
    openTag?: () => void;
    isActive?: boolean;
}

const TagMarker = ({
    isApproved,
    openTag,
    isActive,
    ...rest
}: TagMarkerProps) => {
    const handleOpenTag = useCallback(() => {
        if (openTag) {
            openTag();
        }
    }, [openTag]);

    return (
        <div
            className="relative h-8 w-8 -translate-x-1/2 -translate-y-1/2"
            onMouseEnter={handleOpenTag}
            {...rest}
        >
            {/* Wrapper for animated glowing circle */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <div
                    className={cn(
                        'rounded-full opacity-75',
                        isActive ? 'opacity-0' : 'h-5 w-5 animate-ping',
                        isApproved ? 'bg-gray-300' : 'bg-brick-300',
                    )}
                ></div>
            </div>

            {/* Main marker */}
            <div
                className={cn(
                    'absolute left-1/2 top-1/2 z-sticky h-4 w-4 -translate-x-1/2 -translate-y-1/2 cursor-pointer rounded-full bg-gray-50 opacity-85 transition-all duration-300',
                    isActive && 'h-8 w-8 opacity-50',
                    !isApproved && 'bg-brick-500 opacity-100',
                )}
            ></div>
        </div>
    );
};

export default TagMarker;
